module.exports = __webpack_public_path__ + "img/close.78a35ffb.svg";